/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import * as Types from '../../../../queryTyping';

import { SmsEnrollmentResponseFragment } from './smsEnrollmentFragment';
import { gql } from '@apollo/client';
import { SmsEnrollmentResponseFragmentDoc } from './smsEnrollmentFragment';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type ConfirmSmsEnrollmentMutationVariables = Types.Exact<{
  mobilePhoneId: Types.Scalars['ID'];
  oneTimePassword: Types.Scalars['String'];
}>;


export type ConfirmSmsEnrollmentMutation = (
  { __typename?: 'Mutation' }
  & { confirmSmsEnrollment: Types.Maybe<(
    { __typename?: 'SmsEnrollmentResult' }
    & SmsEnrollmentResponseFragment
  )> }
);


export const ConfirmSmsEnrollmentDocument = gql`
    mutation confirmSmsEnrollment($mobilePhoneId: ID!, $oneTimePassword: String!) {
  confirmSmsEnrollment(
    mobilePhoneId: $mobilePhoneId
    setOneTimePasswordInput: $oneTimePassword
  ) {
    ...SmsEnrollmentResponse
  }
}
    ${SmsEnrollmentResponseFragmentDoc}`;
export type ConfirmSmsEnrollmentMutationFn = Apollo.MutationFunction<ConfirmSmsEnrollmentMutation, ConfirmSmsEnrollmentMutationVariables>;

/**
 * __useConfirmSmsEnrollmentMutation__
 *
 * To run a mutation, you first call `useConfirmSmsEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmSmsEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmSmsEnrollmentMutation, { data, loading, error }] = useConfirmSmsEnrollmentMutation({
 *   variables: {
 *      mobilePhoneId: // value for 'mobilePhoneId'
 *      oneTimePassword: // value for 'oneTimePassword'
 *   },
 * });
 */
export function useConfirmSmsEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmSmsEnrollmentMutation, ConfirmSmsEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmSmsEnrollmentMutation, ConfirmSmsEnrollmentMutationVariables>(ConfirmSmsEnrollmentDocument, options);
      }
export type ConfirmSmsEnrollmentMutationHookResult = ReturnType<typeof useConfirmSmsEnrollmentMutation>;
export type ConfirmSmsEnrollmentMutationResult = Apollo.MutationResult<ConfirmSmsEnrollmentMutation>;
export type ConfirmSmsEnrollmentMutationOptions = Apollo.BaseMutationOptions<ConfirmSmsEnrollmentMutation, ConfirmSmsEnrollmentMutationVariables>;